<template>
  <v-select
      v-bind="$attrs"
      :items="items"
      dense
      outlined
      @input="$emit('input', $event !== '' ? $event : null)"
  >
  </v-select>
</template>

<script>

export default {
  name: 'TemperatureSelect',
  inheritAttrs: false,
  props: {},

  components: {},

  computed: {},

  methods: {},

  async mounted() {
  },

  data() {
    return {
      items: [
        {value: null, text: 'None'},
        {value: 20, text: '20°C'},
        {value: 40, text: '40°C'},
        {value: 90, text: '90°C'},
        {value: 125, text: '125°C'},
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
